import { render, staticRenderFns } from "./KycDetailsTable.vue?vue&type=template&id=1960daf1&scoped=true&"
import script from "./KycDetailsTable.vue?vue&type=script&lang=js&"
export * from "./KycDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./KycDetailsTable.vue?vue&type=style&index=0&id=1960daf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960daf1",
  null
  
)

export default component.exports